function initAjaxLoadMore() {

	window.almComplete = function(alm){
		setTimeout( function() {
			initTilt();
		}, 250 );
	};
}
